var InputStyleTypeEnum;
(function (InputStyleTypeEnum) {
    InputStyleTypeEnum["Text"] = "text";
    InputStyleTypeEnum["Password"] = "password";
    InputStyleTypeEnum["Count"] = "count";
})(InputStyleTypeEnum || (InputStyleTypeEnum = {}));

export { InputStyleTypeEnum };
